module.exports = __webpack_public_path__ + "static/media/gb-ork.b62cd4cf.svg";